// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hf6b","content":"styles_content__34_sa","tableWrap":"styles_tableWrap__3WeiA"};